/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrantRequest } from '../../models/grant-request';
import { ServiceAccountToken } from '../../models/service-account-token';

export interface CreateTokenForExistingUser$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: GrantRequest
}

export function createTokenForExistingUser(http: HttpClient, rootUrl: string, params: CreateTokenForExistingUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceAccountToken>> {
  const rb = new RequestBuilder(rootUrl, createTokenForExistingUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceAccountToken>;
    })
  );
}

createTokenForExistingUser.PATH = '/api/v1/service_account_users/{id}/tokens';
